async function refreshAndOpenCartDrawer() {
  const currentCartDrawer = document.querySelector('#cart');
  if (!currentCartDrawer) {
    window.location.reload();
    return;
  }

  const pageResponse = await fetch(window.location.pathname + window.location.search, {
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  const pageHtml = await pageResponse.text();
  const parsed = new DOMParser().parseFromString(pageHtml, 'text/html');

  const freshCartDrawer = parsed.querySelector('#cart');
  if (!freshCartDrawer) {
    window.location.reload();
    return;
  }

  currentCartDrawer.innerHTML = freshCartDrawer.innerHTML;
  currentCartDrawer.setAttribute('aria-hidden', 'false');

  const possibleOpeners = [
    '[aria-controls="cart"]',
    '[href="#cart"]',
    '[data-cart-open]',
    '.open-cart',
    '.cart-toggle',
    'a[href="/cart"]'
  ];

  let opener = null;

  for (const selector of possibleOpeners) {
    opener = document.querySelector(selector);
    if (opener) break;
  }

  if (opener) {
    opener.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true
    }));
  }
}

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.js-product-card-quick-add [data-product-card-submit]');
  if (!btn) return;

  const form = btn.closest('form.js-product-card-quick-add[action*="/cart/add"]');
  if (!form) return;

  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }

  if (form.dataset.quickAddLocked === 'true') {
    return;
  }

  form.dataset.quickAddLocked = 'true';
  btn.disabled = true;
  btn.setAttribute('aria-disabled', 'true');

  try {
    const formData = new FormData(form);
    
    // Vente par lot : réaligne la quantité sur le lot avant l'envoi (mêmes règles que la fiche produit)
    if (typeof enforcePackQtyOnForm === 'function') {
      enforcePackQtyOnForm(form);
    }

    const addUrl = (window.routes && window.routes.cart_add_url
      ? window.routes.cart_add_url
      : '/cart/add') + '.js';

    const response = await fetch(addUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });

    const responseData = await response.json();

    if (!response.ok || responseData.status) {
      throw new Error(
        responseData.description ||
        responseData.message ||
        "Impossible d'ajouter ce produit au panier."
      );
    }

    if (window.general && window.general.enable_cart_notification && window.cartNotify) {
      window.cartNotify(responseData);
      if (window.ajaxCart && ajaxCart.load) ajaxCart.load(false, false, false, true); // refresh sans ouvrir
    } else {
      await refreshAndOpenCartDrawer();
    }
  } catch (error) {
    console.error('Quick add product-card error:', error);
  } finally {
    window.setTimeout(() => {
      form.dataset.quickAddLocked = 'false';
      btn.disabled = false;
      btn.setAttribute('aria-disabled', 'false');
    }, 1000);
  }
}, true);